import {
    mdiAngular,
    mdiAws,
    mdiBootstrap,
    mdiDatabaseSearch,
    mdiDotNet,
    mdiLanguageJavascript,
    mdiLanguagePhp,
    mdiReact,
    mdiSass
} from "@mdi/js";
import Icon from "@mdi/react";
export default function Atuacao() {
    return (
        <>
            <section id="tecnologias" className="about section light-background">
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-6  d-flex align-items-center justify-content-center">
                            <div className="row text-center w-100" style={{ color: "#999797ff" }}>
                                <div className="col-4 mb-4" data-aos="fade-right" data-aos-delay="100">
                                    <Icon className="" path={mdiLanguageJavascript} size={3.5} />
                                </div>
                                <div className="col-4 mb-4" data-aos="fade-right" data-aos-delay="200">
                                    <Icon path={mdiDotNet} size={3.5} />
                                </div>
                                <div className="col-4 mb-4" data-aos="fade-right" data-aos-delay="300">
                                    <Icon path={mdiReact} size={3.5} />
                                </div>
                                <div className="col-4 mb-4" data-aos="fade-right" data-aos-delay="400">
                                    <Icon path={mdiSass} size={3.5} />
                                </div>
                                <div className="col-4 mb-4" data-aos="fade-right" data-aos-delay="500">
                                    <Icon path={mdiAngular} size={3.5} />
                                </div>
                                <div className="col-4 mb-4" data-aos="fade-right" data-aos-delay="600">
                                    <Icon path={mdiAws} size={3.5} />
                                </div>
                                <div className="col-4 mb-4" data-aos="fade-right" data-aos-delay="700">
                                    <Icon path={mdiLanguagePhp} size={3.5} />
                                </div>
                                <div className="col-4 mb-4" data-aos="fade-right" data-aos-delay="800">
                                    <Icon path={mdiBootstrap} size={3.0} />
                                </div>
                                <div className="col-4 mb-4" data-aos="fade-right" data-aos-delay="900">
                                    <Icon path={mdiDatabaseSearch} size={3.0} />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 " data-aos="fade-left" data-aos-delay="300">
                            <h2>Inovação e tecnologia para impulsionar seu negócio</h2>
                            <p className="fs-5 paragrafo">
                                Utilizamos as ferramentas mais modernas do mercado para criar soluções seguras,
                                escaláveis e de alta performance. Nosso compromisso é entregar projetos que não apenas
                                acompanham, mas antecipam as tendências tecnológicas, garantindo que sua empresa esteja
                                preparada para os desafios do futuro.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
